export default {
  text: 'Keine Internetverbindung. Bitte informieren Sie einen unserer Mitarbeiter, um die Verbindung zu überprüfen 😊',
};
